// extracted by mini-css-extract-plugin
module.exports = {"comment":"_1pIi-lOP7Vlp-EUduCRVKP","timestamp":"_2TuYFOHtwmjd5QLQnchnmz"};